module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d6f130fb79e78e4dd351fd930e742bcc.png";